// Application view constants and routing configuration

export const VIEWS = {
  DASHBOARD: 'dashboard',
  CUSTOMERS: 'customers',
  CUSTOMER_DETAILS: 'customer-details',
  JOBS: 'jobs',
  JOB_DETAILS: 'job-details',
  INVOICES: 'invoices',
  TREATMENT_REPORTS: 'treatment-reports',
  TREATMENT_REPORT_DETAILS: 'treatment-report-details',
  CALENDAR: 'calendar',
  APPOINTMENTS: 'appointments',
  CANVASSING: 'canvassing',
  CANVASSING_MOBILE: 'canvassing-mobile',
  EMAILS: 'emails',
  REMINDERS: 'reminders',
  SETTINGS: 'settings',
  USERS: 'users'
};

export const OAUTH_ROUTES = {
  QUICKBOOKS_CALLBACK: '/quickbooks/callback',
  QUICKBOOKS_RESULT: '/qb/done'
};

export const MODAL_TYPES = {
  ADD_CUSTOMER: 'addCustomer',
  ADD_JOB: 'addJob',
  TREATMENT_REPORT_EDITOR: 'treatmentReportEditor'
};

export const USER_ROLES = {
  ADMIN: 'admin',
  FRANCHISEE: 'franchisee', 
  TECHNICIAN: 'technician'
};

export const JOB_STATUS = {
  SCHEDULED: 'scheduled'
};

export const DATA_LOAD_LIMITS = {
  JOBS: 200
};